import quad from '../images/occupymars/quad.png'
import remote from '../images/occupymars/remote.png'
import rover from '../images/occupymars/rover.png'
import spotty from '../images/occupymars/spotty.png'
import tools from '../images/occupymars/detector.png'
import jetpack from '../images/occupymars/jetpack.png'
import rocket from '../images/occupymars/rocket.png'
import rockets from '../images/occupymars/rockets.png'
import truck from '../images/occupymars/truck.png'
import vertical from '../images/occupymars/Grid_Ramp.png'
import helicopter from '../images/occupymars/helicopter.png'
import motocross from '../images/occupymars/motocross.png'
import suit from '../images/occupymars/suit.png'
import turbine from '../images/occupymars/turbine.png'
import battery from '../images/occupymars/battery.png'
import trailers from '../images/occupymars/trailers.png'
import pumpStations from '../images/occupymars/pump_station.png'
import workshopSink from '../images/occupymars/workshop_sink.png'
import resourceExtr from '../images/occupymars/miner_icon.png'
import centrifuge from '../images/occupymars/Centrifuge.png'
import launchpad from '../images/occupymars/launchpad.png'
import drill from '../images/occupymars/drill_upgrade2_icon.png'
import chemlab from '../images/occupymars/chemlab.png'
import remoterover from '../images/occupymars/remoterover.png'

//tech
import living from '../images/occupymars/living_quarters1_icon.png'
import grinder from '../images/occupymars/grinder_upgrade2_icon.png'
import workbench from '../images/occupymars/HQ_table.png'
import scrubber from '../images/occupymars/scrubber.png'
import sabatier from '../images/occupymars/well_lvl2.png'
import hydroponics from '../images/occupymars/Base biology_icon.png'
import greenhouse from '../images/occupymars/greenhouse_cultivation2_icon.png'
import printer from '../images/occupymars/workshop_3dprinter.png'
import capsule from '../images/occupymars/capsule.png'
import chemistry from '../images/occupymars/Base_chemistry2_icon.png'
import dome from '../images/occupymars/Dome_Cultivation_icon.png'
import electricity from '../images/occupymars/Base_electricity_icon.png'
import radio from '../images/occupymars/radio.png'
import kilopower from '../images/occupymars/kilopower.png'
import antena from '../images/occupymars/antenna_medium.png'
import nuclear from '../images/occupymars/nuclear_reactors_icon.png'
import pressure from '../images/occupymars/AirCompresor_icon.png'

// covers
import c0 from '../images/covers/0.png'
import c1 from '../images/covers/1.png'
import c2 from '../images/covers/2.png'
import c2b from '../images/covers/2b.png'
import c3 from '../images/covers/3.png'
import c4 from '../images/covers/4.png'
import c5 from '../images/covers/5.png'
import c6 from '../images/covers/6.png'
import c7 from '../images/covers/7.png'
import c8 from '../images/covers/8.png'
import c9 from '../images/covers/9.png'

import wip from '../images/occupymars/wip.png'

import OccupyMarsTopBar from '../components/occupyMarsTopBar'

const config = {
    project: {
        name: 'Occupy Mars: The Game',
        description: 'Occupy Mars is a highly technical, open-world sandbox, survival game about Mars colonization. Build and upgrade your base, discover new regions, conduct mining operations, retrieve water, generate oxygen, grow crops, fix broken parts, and learn how to survive on Mars!',
        links: {
            changelog: 'https://steamcommunity.com/app/758690/discussions/0/2447091420212210456/',
            troubleshooting: 'https://steamcommunity.com/app/758690/discussions/0/1749021365362863747/',
            bugtracker: 'https://bugtracker.occupymarsgame.com/',
            steam: 'https://store.steampowered.com/app/758690/Occupy_Mars_The_Game/',
            discord: 'https://discord.gg/d42VhCGfsN',
            website: 'https://occupymarsgame.com/',
        },
        topBar: OccupyMarsTopBar,
    },
    style: {
        default: {
            pageBg: '#e7e7e7',
            navBg: '#e05b37',
            buttonBg: '#984731',
            modalBg: '#ffffff',
            modalFg: '#000000',
            tableBg: '#f6f6f6',
            tableFg: '#000000',
            tableDarkBorder: '#b7b7b7',
            tableLightBorder: '#cfcfcf',
            tableRowLeftHover: '#dedede',
            tableRowRightHover: '#d9d9d9',
            taskBg: '#e9e9e9',
            taskColor: '#7e7e7e',
            taskCompleteColor: '#61ca2f',
        },
        dark: {
            buttonBg: '#f4623a',
            taskColor: '#f4623a',
        }
    },
    settings: {
        startYear: 2019,
        startQuarter: 1,
        quarterLength: 29,
        headerIcons: [c0,,,,c1,,,,c2,,,,c2b,,,,c3,,c4,,c5,,c6,,,,c7,,c8],
        altIcons: ["First alpha",,,,"Demo",,,,"Prologue",,,,"Beta",,,,"Early Access",, "Exploration Update",, "Nuclear Update",, "Anniversary Update",,,, "Online Co-Op",,"1.0"]
    },
    tasks: [
        {
            name: 'Pre-release',
            separ: true,
            description: null,
            completed: false,
            year: 2019,
            quarter: 1,
            quarterLength: 0
        },
        {
            name: 'Demo',
            description: null,
            completed: true,
            year: 2019,
            quarter: 1,
            quarterLength: 5,
        },
        {
            name: 'Prologue',
            description: null,
            completed: true,
            year: 2019,
            quarter: 1,
            quarterLength: 9,
        },
        {
            name: 'Soundtrack',
            description: null,
            completed: true,
            year: 2019,
            quarter: 4,
            quarterLength: 12,
        },
        {
            name: 'Artbook',
            description: null,
            completed: true,
            year: 2020,
            quarter: 4,
            quarterLength: 9,
        },
        {
            name: 'Kickstarter',
            description: null,
            completed: true,
            year: 2022,
            quarter: 3,
            quarterLength: 3,
        },   
        {
            name: 'Early Access - Systems',
            separ: true,
            description: null,
            completed: false,
            year: 2019,
            quarter: 1,
            quarterLength: 0,
        },
        {
            name: 'Core Game Mechanics',
            description: null,
            completed: true,
            year: 2019,
            quarter: 1,
            quarterLength: 9,
        },
        {
            name: 'Engine Version upgrade',
            description: null,
            completed: true,
            year: 2021,
            quarter: 1,
            quarterLength: 4,
        },
        {
            name: 'Terrain & Rocks Rework',
            description: null,
            completed: true,
            year: 2021,
            quarter: 2,
            quarterLength: 6,
        },
        {
            name: 'Interaction System Rework ',
            description: null,
            completed: true,
            year: 2021,
            quarter: 4,
            quarterLength: 5,
        },
        {
            name: 'Character Creator',
            description: null,
            completed: true,
            year: 2020,
            quarter: 1,
            quarterLength: 13,
        },
        {
            name: 'Sandbox Game Mode',
            description: null,
            completed: true,
            year: 2019,
            quarter: 1,
            quarterLength: 17,
        },
        {
            name: 'Weather Events',
            description: null,
            completed: true,
            year: 2019,
            quarter: 1,
            quarterLength: 17,
        },
        {
            name: 'Main Menu & UI Rework',
            description: null,
            completed: true,
            year: 2022,
            quarter: 1,
            quarterLength: 5,
        },
        {
            name: 'Tech Tree Rework',
            description: null,
            completed: true,
            year: 2022,
            quarter: 2,
            quarterLength: 5,
        },
        {
            name: 'Campaign Story Introduction',
            description: null,
            completed: true,
            year: 2021,
            quarter: 2,
            quarterLength: 9,
        },
        {
            name: 'Map Generation System Rework',
            description: null,
            completed: true,
            year: 2023,
            quarter: 1,
            quarterLength: 3,
        },
        {
            name: 'Inventory Box System',
            description: null,
            completed: true,
            year: 2023,
            quarter: 1,
            quarterLength: 3,
        },
        {
            name: 'Tool Durability System',
            description: null,
            completed: true,
            year: 2023,
            quarter: 1,
            quarterLength: 3,
        },
        {
            name: 'Wind Power System',
            description: null,
            completed: true,
            year: 2023,
            quarter: 1,
            quarterLength: 3,
        },
        {
            name: 'Nuclear Power',
            description: null,
            completed: true,
            year: 2023,
            quarter: 3,
            quarterLength: 3,
        },
        {
            name: 'Automated Miners',
            description: null,
            completed: true,
            year: 2023,
            quarter: 3,
            quarterLength: 3,
        },
        {
            name: 'Science Pendrives System',
            description: null,
            completed: true,
            year: 2023,
            quarter: 3,
            quarterLength: 3,
        },
        {
            name: 'Supply Drops System',
            description: null,
            completed: true,
            year: 2023,
            quarter: 3,
            quarterLength: 3,
        },
        {
            name: 'Minigames System',
            description: null,
            completed: true,
            year: 2023,
            quarter: 4,
            quarterLength: 3,
        },
        {
            name: 'Decoration System',
            description: null,
            completed: true,
            year: 2023,
            quarter: 3,
            quarterLength: 5,
        },
        {
            name: 'Electricity System Rework',
            description: null,
            completed: true,
            year: 2023,
            quarter: 4,
            quarterLength: 4,
        },
        {
            name: 'Gardening System Rework',
            description: null,
            completed: true,
            year: 2023,
            quarter: 4,
            quarterLength: 4,
        },
        {
            name: 'Save System Rework',
            description: null,
            completed: true,
            year: 2024,
            quarter: 1,
            quarterLength: 3,
        },
        {
            name: 'Animation System Rework',
            description: null,
            completed: true,
            year: 2024,
            quarter: 1,
            quarterLength: 3,
        },
        {
            name: 'Video Tutorial System',
            description: null,
            completed: true,
            year: 2024,
            quarter: 2,
            quarterLength: 2,
        },
        {
            name: 'Rebalance & QoL',
            description: null,
            completed: true,
            year: 2024,
            quarter: 3,
            quarterLength: 2,
        },
        {
            name: 'Online Co-Op Mode',
            description: null,
            completed: true,
            year: 2023,
            quarter: 1,
            quarterLength: 12,
        },
        {
            name: 'Campaign Story Continuation',
            description: null,
            completed: true,
            year: 2023,
            quarter: 4,
            quarterLength: 10,
        },
        {
            name: 'Technologies',
            separ: true,
            description: null,
            completed: false,
            year: 2019,
            quarter: 1,
            quarterLength: 0,
        },
        {
            name: 'Tech: Core Buildings',
            description: null,
            completed: true,
            year: 2019,
            quarter: 1,
            quarterLength: 4,
            icon: living
        },
        {
            name: 'Tech: Tools',
            description: null,
            completed: true,
            year: 2019,
            quarter: 1,
            quarterLength: 5,
            icon: grinder,
        },
        {
            name: 'Tech: Workbench',
            description: null,
            completed: true,
            year: 2019,
            quarter: 1,
            quarterLength: 6,
            icon: workbench,
        },
        {
            name: 'Tech: CO2 Scrubber',
            description: null,
            completed: true,
            year: 2019,
            quarter: 1,
            quarterLength: 7,
            icon: scrubber,
        },
        {
            name: 'Tech: Sabatier',
            description: null,
            completed: true,
            year: 2019,
            quarter: 1,
            quarterLength: 8,
            icon: sabatier,
        },
        {
            name: 'Tech: Hydroponics',
            description: null,
            completed: true,
            year: 2019,
            quarter: 1,
            quarterLength: 8,
            icon: hydroponics,
        },
        {
            name: 'Tech: Greenhouse',
            description: null,
            completed: true,
            year: 2019,
            quarter: 1,
            quarterLength: 10,
            icon: greenhouse,
        },
        {
            name: 'Tech: Remote Control',
            description: null,
            completed: true,
            year: 2021,
            quarter: 1,
            quarterLength: 3,
            icon: remote
        },
        {
            name: 'Tech: 3D Printer',
            description: null,
            completed: true,
            year: 2019,
            quarter: 1,
            quarterLength: 12,
            icon: printer
        },
        {
            name: 'Tech: Domes',
            description: null,
            completed: true,
            year: 2021,
            quarter: 1,
            quarterLength: 7,
            icon: dome
        },
        {
            name: 'Tech: Landing Capsule',
            description: null,
            completed: true,
            year: 2021,
            quarter: 1,
            quarterLength: 8,
            icon: capsule
        },
        {
            name: 'Tech: Electricity',
            description: null,
            completed: true,
            year: 2019,
            quarter: 1,
            quarterLength: 16,
            icon: electricity
        },
        {
            name: 'Tech: Radio',
            description: null,
            completed: true,
            year: 2022,
            quarter: 3,
            quarterLength: 3,
            icon: radio
        },
        {
            name: 'Tech: Kilopower',
            description: null,
            completed: true,
            year: 2022,
            quarter: 3,
            quarterLength: 7,
            icon: kilopower
        },
        {
            name: 'Tech: Antennas',
            description: null,
            completed: true,
            year: 2023,
            quarter: 1,
            quarterLength: 5,
            icon: antena
        },
        {
            name: 'Tech: Nuclear',
            description: null,
            completed: true,
            year: 2023,
            quarter: 1,
            quarterLength: 5,
            icon: nuclear
        },
        {
            name: 'Tech: Scanning',
            description: null,
            completed: true,
            year: 2024,
            quarter: 1,
            quarterLength: 3,
            icon: tools
        },
        {
            name: 'Tech: Cleaning',
            description: null,
            completed: true,
            year: 2024,
            quarter: 1,
            quarterLength: 3,
            icon: pressure
        },
        {
            name: 'Tech: Grid Constructions',
            description: null,
            completed: true,
            year: 2023,
            quarter: 3,
            quarterLength: 11,
            icon: vertical
        },
        {
            name: 'Tech: Chemistry',
            description: null,
            completed: true,
            year: 2024,
            quarter: 4,
            quarterLength: 6,
            icon: chemistry,
        },
        {
            name: 'Vehicles',
            separ: true,
            description: null,
            completed: false,
            year: 2019,
            quarter: 1,
            quarterLength: 0,
        }, 
        {
            name: 'Heavy Rover',
            description: null,
            completed: true,
            year: 2019,
            quarter: 1,
            quarterLength: 4,
            icon: rover,
        },
        {
            name: 'Quad',
            description: null,
            completed: true,
            year: 2019,
            quarter: 1,
            quarterLength: 5,
            icon: quad,
        },
        {
            name: 'Jetpack',
            description: null,
            completed: true,
            year: 2021,
            quarter: 3,
            quarterLength: 7,
            icon: jetpack,
        },
        {
            name: 'Ingenuity',
            description: null,
            completed: true,
            year: 2021,
            quarter: 4,
            quarterLength: 7,
            icon: helicopter,
        },
        {
            name: 'Motocross',
            description: null,
            completed: true,
            year: 2020,
            quarter: 2,
            quarterLength: 14,
            icon: motocross,
        },
        {
            name: 'Pickup Truck',
            description: null,
            completed: true,
            year: 2022,
            quarter: 1,
            quarterLength: 7,
            icon: truck,
        },
        {
            name: 'Additional Features',
            separ: true,
            description: null,
            completed: false,
            year: 2019,
            quarter: 1,
            quarterLength: 0,
        },
        {
            name: 'Heavy Suit',
            description: null,
            completed: true,
            year: 2022,
            quarter: 4,
            quarterLength: 4,
            icon: suit,
        },
        {
            name: 'Wind Turbines',
            description: null,
            completed: true,
            year: 2023,
            quarter: 1,
            quarterLength: 3,
            icon: turbine,
        },
        {
            name: 'Pump Stations',
            description: null,
            completed: true,
            year: 2023,
            quarter: 1,
            quarterLength: 3,
            icon: pumpStations,
        },
        {
            name: 'Additional trailers',
            description: null,
            completed: true,
            year: 2023,
            quarter: 1,
            quarterLength: 3,
            icon: trailers,
        },
        {
            name: 'Battery Rack',
            description: null,
            completed: true,
            year: 2023,
            quarter: 2,
            quarterLength: 2,
            icon: battery,
        },
        {
            name: 'Workshop Sink',
            description: null,
            completed: true,
            year: 2023,
            quarter: 3,
            quarterLength: 1,
            icon: workshopSink,
        },
        {
            name: 'Resource Extractors',
            description: null,
            completed: true,
            year: 2023,
            quarter: 4,
            quarterLength: 2,
            icon: resourceExtr,
        },
        {
            name: 'Nuclear Centrifuges',
            description: null,
            completed: true,
            year: 2023,
            quarter: 4,
            quarterLength: 2,
            icon: centrifuge,
        },
        {
            name: 'Launchpad',
            description: null,
            completed: true,
            year: 2023,
            quarter: 4,
            quarterLength: 4,
            icon: launchpad,
        },
        {
            name: 'Additional Tools',
            description: null,
            completed: true,
            year: 2024,
            quarter: 2,
            quarterLength: 2,
            icon: drill
        },
        {
            name: 'Robot: Spotty',
            description: null,
            completed: true,
            year: 2024,
            quarter: 2,
            quarterLength: 8,
            icon: spotty,
        },
        {
            name: 'Chemlab Crafting',
            description: null,
            completed: true,
            year: 2025,
            quarter: 1,
            quarterLength: 8,
            icon: chemlab,
        }
    ]
}

export default config
